import React from "react";
import axios from "axios";

function AxiosRequest (method, params) {

    return new Promise((resolve, reject) => {
        let url = `https://api.imbachat.com/imbachat/v1/widget/${method}`;
        axios.post(url, params, {
            headers: {
                'jwt': localStorage.getItem('comet-token'),
                //"Access-Control-Allow-Origin": "*",
            }
        })
            .then((response) => {
                let data = response.data
                if (data.error){
                    reject(data.error)
                } else
                    resolve(data);
            })
            .catch((error) => {
                reject(error)
            })
    })
}

function AxiosRequestWithImba(method, params, imba_id) {
    return new Promise((resolve, reject) => {
        let url = `https://api.imbachat.com/imbachat/v1/${imba_id}/${method}`;
        axios.post(url, params, {
            headers: {
                'jwt': localStorage.getItem('comet-token'),
                //"Access-Control-Allow-Origin": "*",
            }
        })
            .then((response) => {
                let data = response.data
                if (data.error){
                    reject(data.error)
                } else
                    resolve(data);
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export default AxiosRequest;
export {AxiosRequestWithImba};